import $ from 'jquery';
import { showError } from './Errors';

!(function() {
    const empForm = $('.js-employee-appointment-form');
    $(empForm).each((i, element) => {
        const inlineDatepickerElement = $(element).find('.js-inline-datepicker');
        const tabsDatepickerElement = $(element).find('.js-appointment-tabs-datepicker');
        $(inlineDatepickerElement).on('changeDate', () => {
            const newDate = inlineDatepickerElement[0].datepicker.getDate();
            const tabsDate = tabsDatepickerElement[0].tabsDatepicker.getDate();
            if (!tabsDate || newDate.setHours(0, 0, 0, 0) !== tabsDate.setHours(0, 0, 0, 0)) {
                tabsDatepickerElement[0].tabsDatepicker.changeDate(new Date(newDate));
            }
        });
        $(tabsDatepickerElement).on('date:changed', () => {
            const newDate = tabsDatepickerElement[0].tabsDatepicker.getDate();
            const datepickerDate = inlineDatepickerElement[0].datepicker.getDate();
            if (!datepickerDate || newDate.setHours(0, 0, 0, 0) !== datepickerDate.setHours(0, 0, 0, 0)) {
                inlineDatepickerElement[0].datepicker.setDate(new Date(newDate));
            }
        });
        const formEl = tabsDatepickerElement.closest('.js-form')[0];

        $(tabsDatepickerElement).on('date:fetch-success', () => {
            formEl.TurboForm.initInputRequiredListener();
        });
        $(tabsDatepickerElement).on('date:fetch-error', (e, data) => {
            showError(formEl, data.error);
        });
        $(tabsDatepickerElement).on('date:before-fill-time-list', () => {
            formEl.TurboForm.removeInputListener();
            formEl.TurboForm.disableSubmitButton();
        });
    });
})();
